const card = {
  state: {
    currentCard: {} // 点击当前card
  },
  mutations: {
    SET_CURRENTCARD: (state, list) => {
      state.currentCard = list
    }
  },
  actions: {
    getCurrentCard ({
      commit
    }, list) {
      commit('SET_CURRENTCARD', list)
    }
  }
}
export default card



// WEBPACK FOOTER //
// ./src/store/modules/card.js